<script>
    import ImageBank from "../Misc/ImageBank.svelte";
    import ModalButtons from "../Modal/ModalButtons.svelte";
    import WPNSelector from "../Misc/WPNSelector.svelte";
    import dbData from "../../Stores/utilityDBStore.js";
    import { feedbackOptionsForKey, getFeedbackForItem } from "../../scripts/alfxLocation.js";
    import { associatedItemsForEntities, createdItemWithEntity } from "../../scripts/wpn2Model.js";

    export let locationItem;
    // export let item;
    // let feedbackItem;
    let feedbackImageItems = [];
    let fileinput;
    // Options: "show-feedback", "save-image", "play-video"
    let displayMode = "show-feedback";
    let editingFeedbackNote = false;
    let saveImageSrc;
    let leakFlowRate;
    let feedbackNote;

    // $: feedbackItem = getFeedbackForItem(item, $dbData);
    // $: feedbackImageItems = associatedItemsForEntities(['Image'], $dbData.all, feedbackItem, false, false, true, false);

    async function willShowCamera() {
        return;
    }

    const onFileSelected = (e) => {
        const saveImageObject = e.target.files[0]
        let reader = new FileReader();
        reader.readAsDataURL(saveImageObject);
        reader.onload = (e) => {
            saveImageSrc = e.target.result;
            displayMode = "save-image";
        }
    };

    function willSaveImage() {
        // dbData.addOrReplaceItem(feedbackItem);
        const createdImageItem = createdItemWithEntity('Image', locationItem.name ?? "", 'Image', locationItem, $dbData);
        const imageFormat = ['jpg', 'jpeg', 'png'].find((x) => saveImageSrc.substring(0, 32).includes(x)) ?? "unknown";
        createdImageItem['format'] = imageFormat.toUpperCase();
        createdImageItem['image_src'] = saveImageSrc;
        feedbackImageItems.push(createdImageItem);
        dbData.addOrReplaceItem(createdImageItem);
        displayMode = "show-feedback";
        console.log("Image parent / location: ", createdImageItem.parent_uuid, locationItem.uuid);
    }

    function setFeedbackSoundSource(event) {
        locationItem['sound_source'] = event.detail.value;
        // dbData.addOrReplaceItem(feedbackItem);
        return;
    }

    function setFeedbackLeakType(event) {
        locationItem['leak_type'] = event.detail.value;
        // dbData.addOrReplaceItem(feedbackItem);
        return;
    }

    function setFeedbackLeakFlowRate() {
        const lfr = parseFloat(leakFlowRate.value);
        if (lfr != NaN) {
            locationItem['leak_flow_rate'] = lfr * 3.78541;
            // dbData.addOrReplaceItem(feedbackItem);
        }
        return;
    }

    function getFeedbackLeakFlowRateText() {
        const val = locationItem['leak_flow_rate'];
        return (val != undefined) ? (val / 3.78541).toFixed(0) : "";
    }

    function setFeedbackNote() {
        editingFeedbackNote = false;
        locationItem['feedback_note'] = feedbackNote.value ?? "";
        // dbData.addOrReplaceItem(feedbackItem);
        return;
    }

    function resetFeedbackNote() {
        editingFeedbackNote = false;
        // feedbackNote.value = feedbackItem['feedback_note'] ?? "";
        return;
    }

</script>

<div class="detail-section feedback-container">
    {#if displayMode == "show-feedback"}
        <!-- Title + Image File & Camera buttons -->
        <div class="split-title-buttons">
            <div class="detail-section-title split-view-title">Feedback</div>
            <div class="right-buttons-panel">
                <a class="active-link" href={"#"} on:click={() => {fileinput.click();}}>Image</a>
                <a class="link-spacer" href={"#"}>|</a>
                <a class="inactive-link" href={"#"} on:click={willShowCamera}>Camera</a>
            </div>
            <input style="display:none" type="file" accept=".jpg, .jpeg, .png" on:change={(e) => onFileSelected(e)} bind:this={fileinput}/>
        </div>
        {#if feedbackImageItems.length > 0}
            <div class="slideshow-container">
                <ImageBank imageItems={feedbackImageItems} />
            </div>
        {/if}
        <div class="feedback-options-view">
            <div id="feedback-options">
                <!-- Sound Source Dropdown -->
                <div id="sound-source-view">
                    <label for="fb1">Sound Source:</label>
                    <WPNSelector
                        styleOverride="width: 150px"
                        selectorOptions={feedbackOptionsForKey('sound_source')}
                        selectorName="fb1"
                        selected={locationItem['sound_source'] ?? "Unknown"}
                        on:selector-changed={setFeedbackSoundSource}
                    />
                </div>
                <div id="leak-view">
                    {#if locationItem['sound_source'] == "confirmedLeak"}
                        <!-- Leak Type Dropdown -->
                        <div id="leak-type-view">
                            <label for="fb2">Leak Type:</label>
                            <WPNSelector
                                styleOverride="width: 150px"
                                selectorOptions={feedbackOptionsForKey('leak_type')}
                                selectorName="fb2"
                                selected={locationItem['leak_type'] ?? "Unknown"}
                                on:selector-changed={setFeedbackLeakType}
                            />
                        </div>
                        <!-- Leak Flow Rate Number Entry -->
                        <label for="fb3">Leak Flow Rate:</label>
                        <input
                            class="input-item"
                            id="leak-flow-rate"
                            type="number"
                            style="width: 150px"
                            name="fb3"
                            min="0"
                            placeholder="gpm"
                            value={getFeedbackLeakFlowRateText()}
                            bind:this={leakFlowRate}
                            on:change={setFeedbackLeakFlowRate}
                            autocomplete="off"
                        />
                    {/if}
                </div>
            </div>
        </div>
        <div id="feedback-note-view">
            <label for="feedback-note">Feedback Note:</label>
            <textarea 
                name="feedback-note"
                id="feedback-entry"
                rows="3"
                maxlength="256"
                on:focus={() => editingFeedbackNote = true}
                bind:this={feedbackNote}
                >{locationItem['feedback_note'] ?? ""}
            </textarea>
            {#if editingFeedbackNote == true}
            <ModalButtons
                actions={["cancel", "save"]}
                on:cancel={resetFeedbackNote}
                on:save={setFeedbackNote}
            />
            {/if}
        </div>     
    {:else if displayMode == "save-image"}
        <div class="detail-section slideshow-container">
            <div class="detail-section-title">New Image</div>
            <img
                src={saveImageSrc}
                alt="save with utility"
                class="saved-img-photo"
            />
            <ModalButtons
                actions={["cancel", "save"]}
                on:cancel={() => (displayMode = "show-feedback")}
                on:save={willSaveImage}
            />
        </div>
    {/if}
</div>

<style>
    .feedback-container {
        margin: 0 auto;
    }
    .slideshow-container {
        text-align: center;
        max-width: 512px;
        position: relative;
        margin: auto;
    }
    .feedback-options-view {
        padding-bottom: 1rem;
        margin: auto;
    }
    .slideshow-container {
        text-align: center;
        max-width: 512px;
        position: relative;
        margin: auto;
    }
    .saved-img-photo {
        width: 60%;
    }
    #feedback-options {
        display: flex;
    }
    #sound-source-view, #leak-view {
        flex: 1;
    }
    #leak-type-view {
        margin-bottom: 12px;
    }
    #feedback-note-view {
        text-align: center;
    }
    #feedback-entry {
        width: 100%;
    }
</style>